<template>
  <div class="userList electricityBill">
    <!-- 电费账单 electricityBill-->
    <div class="content">
      <!-- <div class="userList-top">
        <span style="font-size:16px">电费账单</span>
        <div class="btns" style="z-index: 8;">  
          报表导出: <el-select v-model="queryTyped" placeholder="请选择账单类型" style="width:70px" size="mini">
            <el-option label="月" value="monthrange" />
            <el-option label="日" value="daterange" />
          </el-select>  
          <el-date-picker size="mini" v-model="value1" @change="daochu" :type="queryTyped" range-separator="至"
            :picker-options="pickerOptions" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div> -->
      <div class="search">
        <el-form ref="form" :model="form" label-width="77px" size="medium" style="display: flex;width: auto;">
          <el-form-item label="用户名">
            <el-input v-model="form.ownerName" placeholder="请输入用户名" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="用户编号">
            <el-input v-model="form.rfid" placeholder="请输入用户编号" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.mobile" placeholder="请输入手机号" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="账单类型">
            <el-select v-model="form.queryType" placeholder="请选择账单类型" style="width:100px">
              <el-option label="年" value="YEAR" />
              <el-option label="月" value="MON" />
              <el-option label="日" value="DAY" />
            </el-select>
          </el-form-item>
          <!--  monthrange daterange-->
          <el-form-item label="账单日期">
            <span v-if="form.queryType=='YEAR'" style="display: flex;">
              <el-date-picker v-model="datetimeValue" type="year" placeholder="选择年" style="width: 100px;"
                value-format="timestamp">
              </el-date-picker>-
              <el-date-picker v-model="datetimeValue2" type="year" placeholder="选择年" style="width: 100px;"
                value-format="timestamp">
              </el-date-picker>
            </span>
            <el-date-picker v-else v-model="datetimeValue" align="right" :picker-options="pickerOptions"
              :type="form.queryType=='DAY'?'daterange':'monthrange'" range-separator="至" placeholder="选择开始日期"
              value-format="timestamp"> </el-date-picker>
          </el-form-item>
        </el-form>
        <el-button type="primary" size="mini" @click="search" class="search-btn">查询</el-button>
        <el-button type="primary" size="mini" @click="daochu" class="search-btn">导出</el-button>
      </div>

      <div class="userList-table" :style="{'height':heights+'px'}">
        <el-table ref="table" :data="tableData2" v-loading="loading" stripe style="width: 100%"
          :max-height="heights - 20" row-key="id" @expand-change="load">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.children" style="width: 100%" v-loading="loading2"
                header-row-class-name="tableNest">
                <template slot="empty">
                  <span class="noData">
                    <img src="../../assets/noData.png" alt="暂无数据">
                    <span class="text">暂无数据</span>
                  </span>
                </template>
                <el-table-column label="设备号" min-width="70" align="center">
                  <template slot-scope="props">
                    <span>
                      {{props.row['抄表信息']['设备号']}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="设备名" min-width="180" align="center">
                  <template slot-scope="props">
                    <span>
                      {{props.row['抄表信息']['设备名']}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="开始读数" min-width="110" align="center">
                  <template slot-scope="props">
                    <span>
                      {{props.row['抄表信息']['开始读数']}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="结束读数" min-width="110" align="center">
                  <template slot-scope="props">
                    <span>
                      {{props.row['抄表信息']['结束读数']}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="开始时间" min-width="210" align="center">
                  <template slot-scope="props">
                    <span>
                      {{props.row['抄表信息']['开始时间']}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="结束时间" min-width="210" align="center">
                  <template slot-scope="props">
                    <span>
                      {{props.row['抄表信息']['结束时间']}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="总用量(kW-h)" min-width="150" align="center">
                  <template slot-scope="props">
                    <span>
                      {{props.row['抄表信息']['总用量']}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="总金额(元)" min-width="110" align="center">
                  <template slot-scope="props">
                    <span>
                      {{props.row['抄表信息']['总金额']}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="单价(元)" min-width="110" align="center">
                  <template slot-scope="props">
                    <span>
                      {{props.row['抄表信息']['设备单价']}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="180" align="center">
                  <template slot-scope="{row}">
                    <el-button type="text" @click="detailFn(row['抄表信息']['设备号'],props.row)">查看详情</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>

          <el-table-column prop="username" label="用户名" min-width="137" align="center" />
          <el-table-column prop="rfid" label="用户编号" min-width="137" align="center" />
          <el-table-column prop="mobile" label="手机" min-width="137" align="center" />
          <el-table-column label="账单类型" min-width="137" align="center">
            <template slot-scope="props">
              <el-tag v-if="props.row.billType=='日账单'" size="small">日账单</el-tag>
              <el-tag v-if="props.row.billType=='月账单'" size="small" type="success">月账单</el-tag>
              <el-tag v-if="props.row.billType=='年账单'" size="small" type="warning">年账单</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="totalAmount" label="总金额(元)" min-width="137" align="center" />
          <el-table-column prop="billName" label="账单名称" min-width="137" align="center" />
        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          background :page-sizes="[15, 25, 35, 45, 55]" :page-size="15" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <downloadTable ref="downloadTable"></downloadTable>
    </div>

    <!-- 详情 -->
    <el-dialog title="详情" v-dialogDrag :visible.sync="detail_status" width="400" center>
      <el-table :data="childrenList" style="width: 100%" header-row-class-name="tableNest">
        <el-table-column prop="业主名" label="业主名" min-width="80" align="center" />
        <el-table-column prop="合计费用" label="合计费用" min-width="110" align="center" />
        <el-table-column prop="开始时间" label="开始时间" min-width="220" align="center" />
        <el-table-column prop="开始读数" label="开始读数" min-width="110" align="center" />
        <el-table-column prop="用电量" label="用电量" min-width="70" align="center" />
        <el-table-column prop="结束时间" label="结束时间" min-width="220" align="center" />
        <el-table-column prop="结束读数" label="结束读数" min-width="110" align="center" />
        <el-table-column prop="表名" label="表名" min-width="220" align="center" />
      </el-table>
      <el-pagination layout="prev, pager, next" :total="children_total" @current-change="changeFn" />
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="detail_status = false">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import {findOperatingRecord,findRecordType} from "../../api/zhongshanMeter";
  import resourcesStore from '@/cache/resourcesStore.js'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      downloadTable
    },
    data () {
      return {
        queryTyped: 'monthrange',
        value1: '',
        baseUrl: DWSystemSetting.baseURL,
        uniId: this.$store.unitStore.getters.getNowUnit.id,
        Time: '1685592000000',
        loadingBtn: false,
        children_total: 0,
        children_params: {},//请求参数
        detail_status: false,//详情弹窗
        childrenList: [],//详情数据
        loading2: false,
        tableData3: [{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },],
        tableData2: [],
        heji: {},//合计
        heights: document.getElementById('app').clientHeight-300,//屏幕高度 - 导航栏高度
        // 操作类型
        recordTypeList: [],
        //加载中
        loading: false,
        form: {
          queryType: 'DAY'
        },
        searchflag: false,//是否搜索过
        //查询
        total: 0,
        currentPage: 1,
        currentSize: 15,
        tableData: [],//表格数据
        datetimeValue: [new Date('2023/6/1').getTime(),new Date().getTime()-86400000],
        datetimeValue2: '',
        startDate: '',//日期
        endDate: new Date().getTime(),//日期
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>(Date.now()-86400000);
          }
        },
      };
    },

    mounted () {
      this.getDataList() //获取列表数据
      const currentDate=new Date();
      const lastMonth=new Date(currentDate.getFullYear(),currentDate.getMonth()-1,currentDate.getDate());
      this.Time=lastMonth.getTime()
    },
    methods: {
      // 导出
      daochu () {

        var params={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          'startTime': this.datetimeValue[0],
          'endTime': this.datetimeValue[1],
          'queryType': this.form.queryType,
          ownerName: this.form.ownerName,
          rfid: this.form.rfid,
          mobile: this.form.mobile,
        }
        if(this.form.queryType=='YEAR') {
          params.startTime=this.datetimeValue;
          params.endTime=this.datetimeValue2;
        }
        var d=this.form.queryType;
        console.log(d,'d');
        const link=document.createElement('a');
        link.style.display='none';
        link.href=this.baseUrl+'/revenueManagement/exportElectricityBill?queryType='+d+'&unitId='+this.uniId+'&startTime='+params.startTime+'&endTime='+params.endTime;
        console.log(link.href);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      // 详情分页
      changeFn (v) {
        var params=this.children_params;
        params.pageIndex=v;
        request({url: "/revenueManagement/getElectricityBill.do",method: "get",params}).then(res => {

          if(res.success) {
            this.childrenList=res.data.dataList;
            this.children_total=res.data.total;
          }
        })
      },
      detailFn (v,row) {

        this.detail_status=true;
        var d=row.billName.slice(0,10);
        d=d? new Date(d).getTime():0;
        var params={
          'userId': row.user_id,
          'queryTime': d,
          'pageIndex': 1,
          'pageSize': 10,
          'deviceNos': v,
          'queryType': row.billTypeEnum
        }
        this.$router.push({
          name: 'electricityList',
          query: {
            params
          }
        })
        return
        this.children_params=params;
        request({url: "/revenueManagement/getElectricityBill.do",method: "get",params}).then(res => {

          if(res.success) {
            this.childrenList=res.data.dataList;
            this.children_total=res.data.total;
          }
        })
      },
      // 懒加载
      load (row,en) {
        // this.tableData2.map(v => {
        //   if(v.id!=row.id) {
        //     this.$refs.table.toggleRowExpansion(v,false)
        //   }
        // })

        if(!en.length||row.children) {
          return
        }

        var d=row.billName.slice(0,-2);
        d=d? new Date(d).getTime():0;
        // targetId，queryTime，queryType
        console.log(row,'row');
        var params={
          'targetId': row.user_id,
          'queryTime': d,
          'queryType': row.billTypeEnum
        }
        this.loading2=true;
        request({url: "/revenueManagement/getDeviceRecordListByOwnerId.do",method: "get",params}).then(res => {
          this.loading2=false;
          if(res.code==200) {
            row.children=res.data;
          }
        })
      },
      //搜索
      search () {
        this.searchflag=true;//已搜索
        var params={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          'startTime': this.datetimeValue[0],
          'endTime': this.datetimeValue[1],
          'queryType': this.form.queryType,
          ownerName: this.form.ownerName,
          rfid: this.form.rfid,
          mobile: this.form.mobile,
        }
        if(this.form.queryType=='YEAR') {
          params.startTime=this.datetimeValue;
          params.endTime=this.datetimeValue2;
        }
        this.loading=true;
        request({url: "/revenueManagement/getZHSettlementBill.do",method: "get",params}).then(res => {
          this.loading=false;
          console.log(res,1);
          if(res.code==200) {
            this.tableData2=res.data.dataList
            this.total=res.data.total
          }
        })
      },
      // 获取列表信息
      getDataList () {
        var params={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,

        }
        this.loading=true
        request({url: "/revenueManagement/searchSettlementBill.do",method: "get",params}).then(res => {
          this.loading=false
          if(res.success) {
            this.tableData2=res.data.dataList
            this.total=res.data.total
          }
        })
      },



      //下载表格excel
      exportList () {

        var params={
          unitId: this.$store.unitStore.state.nowUnit.id,
          queryType: 'MON',
          startTime: '1685625055'
        }
        console.log(params);
        request({url: "/revenueManagement/exportElectricityBill",method: "get",params}).then(res => {
          const link=document.createElement('a');
          let blob=new Blob([res],{type: 'application/x-excel'});
          link.style.display='none';
          link.href=URL.createObjectURL(blob);
          link.download='电费账单.xls';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        return

        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-电费账单','.userList-table')
        //  queryType
        // queryTime
        // ownerName
        // rfid
        // mobile
        // fileName
        console.log(112);
        // var params={
        //   fileName: '电费账单',
        //   'pageIndex': this.currentPage,
        //   'pageSize': this.currentSize,
        //   'startTime': this.datetimeValue[0],
        //   'endTime': this.datetimeValue[1],
        //   'queryType': this.form.queryType,
        //   ownerName: this.form.ownerName,
        //   rfid: this.form.rfid,
        //   mobile: this.form.mobile,
        // }
        // this.loadingBtn=true;
        // request({url: "/revenueManagement/exportElectricityBill.do",method: "get",params}).then(res => {
        //   this.loadingBtn=false;
        //   const link=document.createElement('a');
        //   let blob=new Blob([res],{type: 'application/x-excel'});
        //   link.style.display='none';
        //   link.href=URL.createObjectURL(blob);
        //   link.download='电费账单.xls';
        //   document.body.appendChild(link);
        //   link.click();
        //   document.body.removeChild(link);
        // })
      },
      openDownloadFile (urlObj,saveName) {
        var openDownload=function(href,fileName) {
          var downloadElement=document.createElement('a');
          downloadElement.target="_blank";
          downloadElement.href=href;
          downloadElement.download=fileName||""; // HTML5新增的属性，指定保存文件名，可以不要后缀
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
        }

        if(typeof urlObj=='object'&&urlObj instanceof Blob) {
          if(window.navigator&&window.navigator.msSaveOrOpenBlob) {
            //针对于IE浏览器的处理, 因部分IE浏览器不支持createObjectURL
            window.navigator.msSaveOrOpenBlob(urlObj,saveName);
          } else {
            var url=window.URL.createObjectURL(urlObj); // 创建blob地址
            openDownload(url,saveName);
            window.URL.revokeObjectURL(url); // 释放掉blob对象创建的地址
          }
        } else {
          openDownload(urlObj,saveName);
        }
      },
      //分页功能
      newgetNowPageDataList (v) {
        // 当前页显示
        if(this.searchflag) {
          this.search()
        } else {
          this.getDataList()
        }
      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>
<style>
  .electricityBill .tableNest th {
    background-color: #f5f8fa !important;
    color: #999 !important;
  }

  .electricityBill .el-table__expanded-cell {
    background-color: #f5f8fa !important;
  }

  .electricityBill .el-table__expanded-cell {
    padding: 5px;
    padding-right: 0;
    padding-bottom: 0;
    padding-left: 44px;
  }
</style>
<style lang="scss" scoped>
  .box {
    display: flex;
    border: 1px solid #E6E6E6;
    justify-content: space-between;
    margin: 20px;
    height: 100px;
    box-sizing: border-box;
    padding: 20px 0;
  }

  .box .li {
    flex: 1;
    display: flex;
    justify-content: center;
    border-left: 1px solid #E6E6E6;
  }

  .box .li img {
    margin-right: 15px;
  }

  .box .li .t {
    font-size: 24px;
    font-weight: bold;
    color: #1A1A1A;
  }

  .box .li .b {
    font-size: 16px;
    font-weight: 400;
    color: #999;
  }

  .box .li:nth-child(1) {
    border-left: none;
  }

  .userList {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      overflow: hidden;

      .userList-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // height: 50px;
        margin: 0px 20px;
        padding: 20px 0px 12px 0px;
        border-bottom: 2px solid #E6E6E6;

        .user-left {
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            height: 50px;
            line-height: 50px;
            margin-right: 40px;
            cursor: pointer;
            color: #999999;

            &.active {
              color: #359eff;
              font-weight: bold;
              border-bottom: 2px solid #359eff;
            }
          }
        }



      }

      .search::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        background-color: #d7d7d7;
      }

      .search {
        display: flex;
        align-items: center;
        margin: 12px 0px 20px 0px;
        position: relative;
        left: -3px;

        .el-form-item {
          margin-bottom: 0px;
        }

        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 350px;
        }
      }

      .userList-table {
        margin: 0px 20px;

        .el-table th {
          border-right: 1px solid #E6E6E6;
        }

        .el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }





      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
        margin-right: 15px;
      }

    }

    .el-form-item__label {
      padding: 0px;
    }



  }
</style>